import React, { useState } from "react";
import axios from "../../lib/axios.js";
import "./ForgotPassword.css"; // ✅ rename CSS to match shared login style

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await axios.post("/auth/forgot-password", { email });
      setMessage(res.data.message);
    } catch (err) {
      setMessage(err.response?.data?.message || "Something went wrong");
    }
  };

  return (
    <div className="loginsignup">
      <div className="loginsignup-container">
        <h2 className="loginsignup-title">Forgot Password</h2>

        <form onSubmit={handleSubmit} className="loginsignup-fields">
          <div className="input-wrapper">
            <input
              type="email"
              placeholder="Enter your registered email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>

          <button type="submit" className="loginsignup-button">
            Send Reset Link
          </button>
        </form>

        {message && <p className="input-error">{message}</p>}
      </div>
    </div>
  );
};

export default ForgotPassword;
